module.exports = __webpack_public_path__ + "static/media/4.6411ff41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/4.svg
// module id = 409
// module chunks = 14